<template>
  <svg viewBox="0 0 1196 1207" role="img" aria-label="The flowchart’s nodes and branches reconstructed from its Mermaid representation">
    <defs><marker :id="markerId" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse"><path d="M0 0 10 5 0 10z" fill="#777777" /></marker></defs>
    <rect width="1196" height="1207" fill="#ffffff" />
    <g fill="none" stroke="#777777" stroke-width="2" :marker-end="`url(#${markerId})`">
      <path d="M229 90V164" /><path d="M212 324 190 466" /><path d="M286 300 488 463" />
      <path d="M512 572 447 692" /><path d="M604 560 770 692" /><path d="M816 774V859" />
      <path d="M764 987 646 1117" /><path d="M868 987 975 1117" />
    </g>
    <g font-family="Arial, sans-serif" font-size="23" fill="#666666">
      <text x="215" y="391">No</text><text x="408" y="391">Yes</text><text x="487" y="652">No</text><text x="727" y="652">Yes</text><text x="715" y="1076">Yes</text><text x="946" y="1076">No</text>
    </g>
    <g fill="#f4f4f4" stroke="#777777" stroke-width="2">
      <rect x="53" y="9" width="353" height="80" rx="9" /><rect x="9" y="473" width="353" height="80" rx="9" />
      <rect x="249" y="694" width="351" height="80" rx="9" /><rect x="640" y="694" width="352" height="80" rx="9" />
      <rect x="444" y="1119" width="353" height="80" rx="9" /><rect x="835" y="1119" width="353" height="80" rx="9" />
      <path d="M229 179 364 251 229 324 94 251Z" fill="#e8e8e8" />
      <path d="M545 440 675 512 545 585 415 512Z" fill="#e8e8e8" />
      <path d="M816 865 945 937 816 1009 686 937Z" fill="#e8e8e8" />
    </g>
    <g font-family="Arial, sans-serif" font-size="24" fill="#343434" text-anchor="middle">
      <text x="229.5" y="58">Submission received</text><text x="185.5" y="522">Return to applicant</text>
      <text x="424.5" y="745">Standard assessment</text><text x="816" y="745">Verify against Table 1</text>
      <text x="620.5" y="1169">Grant exemption</text><text x="1011.5" y="1169">Refuse exemption</text>
      <text x="229" y="247">Area schedule<tspan x="229" dy="27">attached?</tspan></text>
      <text x="545" y="510">Exemption<tspan x="545" dy="27">claimed?</tspan></text>
      <text x="816" y="933">Conditions in<tspan x="816" dy="27">Notes met?</tspan></text>
    </g>
  </svg>
</template>
<script>
let serial = 0;
export default { name: 'RagFlowchartRender', data() { return { markerId: `rag-flow-arrow-${++serial}` }; } };
</script>
